import { useFlags } from 'launchdarkly-react-client-sdk';
import { FeatureFlags } from '../types/featureFlags';

/**
 * Hook to access LaunchDarkly feature flags
 * LaunchDarkly SDK automatically converts kebab-case flag keys to camelCase
 * So 'access-config' in LaunchDarkly becomes 'accessConfig' in the flags object
 * @returns All feature flags configured in LaunchDarkly
 */
export const useFeatureFlags = (): FeatureFlags => {
  const flags = useFlags();
  
  // LaunchDarkly SDK automatically converts 'access-config' to 'accessConfig'
  // Provide fallback to ensure we always return a valid structure
  const accessConfig = flags.accessConfig || {
    enabled: false,
    showToAll: false,
    showToUserIds: [],
  };
  
  return {
    accessConfig,
  };
};

